<header id="sticky">

  <!-- ── DESKTOP (>768px) ─────────────────────────────────────────── -->
  <div class="header-desktop">
    <div class="container">
      <div class="main-menu">
        <div class="menu-left">
          <div class="brand-logo">
            <a (click)="goHome()">
              <img src="assets/images/logos/logo-distrimay.png" class="img-logo" alt="Distrimay" />
            </a>
          </div>
        </div>
        <div>
          <form class="form_search" role="form">
            <input
              id="query search-autocomplete"
              class="nav-search nav-search-field"
              aria-expanded="true"
              name="search"
              placeholder="{{ 'search' | translate }}"
              [(ngModel)]="searchArticle"
              (keyup.enter)="findWeb()"
            />
            <button type="button" name="nav-submit-button" class="btn-search" (click)="findWeb()">
              <span class="material-icons">search</span>
            </button>
          </form>
        </div>
        <div class="menu-right pull-right">
          <div>
            <app-header-widgets></app-header-widgets>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── MOBILE (≤768px) ──────────────────────────────────────────── -->
  <div class="header-mobile">
    <div class="hm-row">

      <a (click)="goHome()" class="hm-logo">
        <img src="assets/images/logos/logo-distrimay.png" class="img-logo-mobile" alt="Distrimay" />
      </a>

      <form class="form_search hm-search" role="form">
        <input
          class="nav-search nav-search-field"
          name="search-mobile"
          placeholder="{{ 'search' | translate }}"
          [(ngModel)]="searchArticle"
          (keyup.enter)="findWeb()"
        />
        <button type="button" class="btn-search" (click)="findWeb()">
          <span class="material-icons">search</span>
        </button>
      </form>

      <div class="hm-actions">
        <app-topbar></app-topbar>
        <a class="mobile-cart-btn" [routerLink]="'/home/cart'">
          <span class="material-icons">shopping_cart</span>
          @if (cartCount > 0) {
            <span class="mobile-cart-badge">{{ cartCount }}</span>
          }
        </a>
      </div>

    </div>
  </div>

  <img src="assets/images/header/header-bg.png" class="border-header" alt="Distrimay" />

</header>
